import { render, staticRenderFns } from "./NewSearch.vue?vue&type=template&id=05e846dc&scoped=true&"
import script from "./NewSearch.vue?vue&type=script&lang=js&"
export * from "./NewSearch.vue?vue&type=script&lang=js&"
import style0 from "./NewSearch.vue?vue&type=style&index=0&id=05e846dc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05e846dc",
  null
  
)

export default component.exports